import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const FirstName = (props: InputComponentProps) => {
  const validate = ({ value }) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]+$/;
    if (value.trim().length < 1) return 'Please enter your first name';
    if (!regex.test(value.trim())) return 'Please enter a valid name';

    return true;
  };

  return (
    <ValidatingInput
      autoComplete="given-name"
      label="First name"
      name="firstName"
      placeholder="First name"
      validate={validate}
      {...props}
    />
  );
};
